import React from 'react';
import { useState } from 'react';
import { getAllRejectedByYearAndSearch, resetRejection } from './service';
import View from './RejectedReset.view';
import errorCb from 'Common/Utils/errorCb';
import { useDispatch } from 'react-redux';
import { infoToastAction, errorToastAction } from 'utils';
import { useSelector } from 'react-redux';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const ResetRejectedAppointments = () => {
    document.title = `Contract Management - Reset Rejected Contract`;    
	const [data, setData] = useState([]);
	const [isSelected, setisSelected] = useState(false);
	const { selected: qualYear } = useSelector(qualYearSelect);	
	const dispatch = useDispatch();
	const [searchId, setSearchId] = useState('');
	const [selectedRow, setSelectedRowState] = useState([]);
	const [searchYear, updateSearchYear] = useState(qualYear.toString());
	const globalDispatch = useDispatch();

	const setSelectedRow = row => {
		setSelectedRowState(row);
		setisSelected(true);
	};

	const updateYear = async year => {
        updateSearchYear(year);
		setisSelected(false);
		setSelectedRowState([]);
		setData([]);
    };

	const resetContract = async () => {
		
		let dto = {
			year: selectedRow.qualificationYear,
			searchId: selectedRow.appointmentId
		};
		const result = await resetRejection(dto, errorCb([], 'Error resetting contract:' + dto.searchId, dispatch));

		if(result)
		{
			globalDispatch(infoToastAction('Appointment reset successfully'));
			await loadData();
		}
		else
		{
			globalDispatch(errorToastAction('Error resetting appointment'));			
		}

	}

	//	Do the search
	const submit = async () => {
		await loadData();
	};

	const loadData = async () => {
		var result = [];

		if(searchId != '')
		{
			await getAllRejectedByYearAndSearch(searchYear, searchId, errorCb([], 'Error fetching data.', dispatch)).then(res => {
				result = res;
			});
		}

		setData(result);
		setisSelected(false);
		setSelectedRowState([]);

		if(result.length == 0)
		{
			globalDispatch(infoToastAction('No results found for your search'));
		}
	}

	return (
		<View
			data={data}
			submit={submit}
			updateYear={updateYear}
			setSearchId={setSearchId}
			onSelectionChange={setSelectedRow}
			resetContract={resetContract}
			isSelected={isSelected}
			selectedRow={selectedRow}
			searchYear={searchYear}
		/>
	);
};

export default ResetRejectedAppointments;
